import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import ArrowLink from '../ArrowLink/ArrowLink';

import './StatisticsNugget.scss';

class StatisticsNugget extends Component {
  static propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    titleClick: PropTypes.func,
    className: PropTypes.string
  };

  render() {
    const className = classnames({
      statistics__nugget: true,
      [this.props.className]: this.props.className
    });

    return (
      <div className={className}>
        <ArrowLink onClick={this.props.titleClick} title={this.props.title} />
        <div className="statistics__nugget--details">{this.props.children}</div>
      </div>
    );
  }
}

export default StatisticsNugget;
